import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'CORE';

type EventAction = 'SIGN_UP';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportSignUp = () => {
  report({
    hitType: 'event',
    eventCategory: 'CORE',
    eventAction: 'SIGN_UP',
  });
};
